export const getFileExtension = ({
  fileName,
}: {
  fileName: string | undefined;
}) => `.${(fileName || "").split(".").pop()?.toLowerCase() || ""}`;
